import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExclaimationMark = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "currentColor",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M11.776 24a2.017 2.017 0 0 1-1.865-1.234 1.984 1.984 0 0 1 .437-2.18 2.03 2.03 0 0 1 2.2-.434 1.99 1.99 0 0 1 .655 3.262 2.027 2.027 0 0 1-1.427.586Zm3.76-21.5L14.016 16a2.25 2.25 0 0 1-2.241 1.977A2.25 2.25 0 0 1 9.534 16L8.016 2.5A2.215 2.215 0 0 1 8.57.75 2.264 2.264 0 0 1 10.262 0h3.028a2.264 2.264 0 0 1 1.691.75c.43.477.631 1.115.554 1.75Z" })
});
export default SvgExclaimationMark;
